import React, { useEffect, useState } from "react";
import { getChatsHeads, readMessages } from "../../../API/ChatAPI/ChatApi";
import Loader from "../../../components/Loader/Loader";
import { getSocket } from "../../../socket/socket";
import { MdAttachFile } from "react-icons/md";

const ChatHeads = ({
  setChatList,
  chatsHeads,
  setChatsHeads,
  setSelectedChat,
  selectedChat,
}) => {
  const [loadingfetchChatHeads, setLoadingFetchChatHeads] = useState(false);

  useEffect(() => {
    const socket = getSocket();

    // Listen for chat events
    socket.on("newMessage", (message) => {
      const updatedChats = [
        ...chatsHeads.filter(
          (chat) =>
            message.senderId.toString() === chat.otherUser._id.toString() // Move specific chat to top
        ),
        ...chatsHeads.filter(
          (chat) =>
            message.senderId.toString() !== chat.otherUser._id.toString() // Keep other chats as is
        ),
      ];
      setChatsHeads(() => {
        let prev = updatedChats.map((item) => {
          if (item.otherUser._id.toString() === message.senderId.toString()) {
            if (selectedChat) {
              if (
                !(selectedChat.otherUser._id === message.senderId.toString())
              ) {
                item.unreadMessages = item.unreadMessages + 1;
              }
            } else {
              item.unreadMessages = item.unreadMessages + 1;
            }
            item.textMessage = message.textMessage;
            return item;
          } else {
            return item;
          }
        });
        return prev;
      });
      if (selectedChat) {
        if (
          message.senderId.toString() === selectedChat.otherUser._id.toString()
        ) {
          setChatList((prevMessages) => [...prevMessages, message]);
          readMessages({ senderId: message.senderId.toString() });
        }
      }
    });

    // Cleanup on unmount
    return () => {
      socket.off("newMessage"); // Remove listener
    };
  }, [selectedChat, setChatsHeads, chatsHeads, setChatList]);

  useEffect(() => {
    if (selectedChat) {
      readMessages({ senderId: selectedChat.otherUser._id.toString() });
      setChatsHeads((prev) => {
        prev = prev.map((item) => {
          if (
            item.otherUser._id.toString() ===
            selectedChat.otherUser._id.toString()
          ) {
            selectedChat.unreadMessages = 0;
            return selectedChat;
          } else {
            return item;
          }
        });
        return prev;
      });
    }
  }, [selectedChat, setChatsHeads]);

  useEffect(() => {
    const fetchChatHeads = async () => {
      try {
        setLoadingFetchChatHeads(true);
        const chatsHeads = await getChatsHeads();
        setChatsHeads(chatsHeads);
        setLoadingFetchChatHeads(false);
      } catch (error) {
        console.error(error);
        setLoadingFetchChatHeads(false);
      }
    };

    fetchChatHeads();
  }, [setChatsHeads]);

  function getDateText(date) {
    const givenDate = new Date(date);
    const today = new Date();
    const todayMidnight = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate()
    );
    const givenDateMidnight = new Date(
      givenDate.getFullYear(),
      givenDate.getMonth(),
      givenDate.getDate()
    );
    const timeDifference = todayMidnight - givenDateMidnight;
    const dayDifference = timeDifference / (1000 * 60 * 60 * 24);

    if (dayDifference === 0) return "Today";
    if (dayDifference === 1) return "Yesterday";

    const options = { year: "numeric", month: "long", day: "numeric" };
    return givenDate.toLocaleDateString(undefined, options);
  }

  return (
    <div className="md:w-[370px] border-r border-gray-200 relative h-full bg-white">
      {/* Header */}
      <div className="p-4 border-b border-gray-200 bg-gray-50">
        <h1 className="text-lg font-semibold text-gray-900 text-center">
          Conversations
        </h1>
        <p className="text-sm text-gray-500 text-center mt-1">
          {chatsHeads?.length || 0} active chats
        </p>
      </div>

      {loadingfetchChatHeads ? (
        <div className="flex justify-center items-center absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
          <Loader />
        </div>
      ) : (
        <div className="overflow-y-auto h-full">
          {chatsHeads?.length === 0 ? (
            <div className="flex flex-col items-center justify-center h-64 text-gray-500">
              <div className="text-4xl mb-2">💬</div>
              <p className="text-sm">No conversations yet</p>
            </div>
          ) : (
            chatsHeads?.map((item) => (
              <div
                key={item?._id}
                className={`flex items-center justify-between gap-3 px-4 py-3 border-b border-gray-100 hover:bg-gray-50 cursor-pointer transition-colors ${
                  selectedChat?.otherUser?._id === item?.otherUser?._id
                    ? "border-l-4 border-l-[--primary] bg-gray-50" // Highlight selected chat head with left border
                    : ""
                }`}
                onClick={() => setSelectedChat(item)} // Select chat head
              >
                <div className="flex items-center gap-3 flex-1 min-w-0">
                  <div className="flex-shrink-0">
                    {item?.otherUser?.profilePhoto ? (
                      <img
                        className="w-12 h-12 rounded-full object-cover"
                        src={item?.otherUser?.profilePhoto}
                        alt="profileimage"
                      />
                    ) : (
                      <div className="w-12 h-12 rounded-full bg-[--primary] flex items-center justify-center text-white font-medium">
                        {item?.otherUser?.firstName?.charAt(0)}{item?.otherUser?.lastName?.charAt(0)}
                      </div>
                    )}
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between">
                      <div className="text-sm font-semibold text-gray-900 truncate">
                        {item?.otherUser?.firstName} {item?.otherUser?.lastName}
                      </div>
                      <div className="text-xs text-gray-500 ml-2">
                        {getDateText(item?.createdAt)}
                      </div>
                    </div>
                    <div className="flex items-center justify-between mt-1">
                      <div className="text-xs text-gray-500 truncate flex-1">
                        {item.imageMessage ? (
                          <div className="flex gap-1 items-center">
                            <MdAttachFile className="text-sm" />
                            <span>File attached</span>
                          </div>
                        ) : (
                          <span className="truncate">{item?.textMessage || "No messages yet"}</span>
                        )}
                      </div>
                      {/* Unread messages badge */}
                      {item?.unreadMessages > 0 && (
                        <span className="ml-2 text-xs bg-[--primary] text-white font-semibold py-1 px-2 rounded-full min-w-[20px] text-center">
                          {item.unreadMessages}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default ChatHeads;
